/* Cart drawer extras: savings, shipping estimate, upsells, discount codes. Runs alongside theme-core.js. */
(function () {
  var S = window.SITRA || {};
  var root = ((S.routes && S.routes.root) || '/').replace(/\/?$/, '/');
  var d, lastKey = '', recCache = {};
  function $(s, c) { return (c || document).querySelector(s); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return S.money ? S.money(c) : '$' + (c / 100).toFixed(2); }
  function rate() { try { return +(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1; } catch (e) { return 1; } }
  function flatCents() { var m = String(S.flatShip || '').replace(/,/g, '').match(/[\d.]+/); return m ? Math.round(parseFloat(m[0]) * 100 * rate()) : 0; }
  function cart() { return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }

  function summary(c) {
    var save = 0;
    c.items.forEach(function (it) { save += Math.max(0, (it.original_line_price || 0) - (it.final_line_price || 0)); });
    save += c.total_discount && c.total_discount > save ? c.total_discount - save : 0;
    var th = S.freeShip || 0, free = th && c.total_price >= th, ship = free ? 0 : flatCents();
    var set = function (sel, v) { var el = $(sel, d); if (el) el.textContent = v; };
    var sr = $('[data-cx-save-row]', d); if (sr) sr.hidden = !save;
    set('[data-cx-save]', '−' + money(save));
    set('[data-cx-ship]', free ? 'Free' : (ship ? money(ship) : 'Calculated at checkout'));
    set('[data-cx-total]', money(c.total_price + ship));
    set('[data-cx-checkout-total]', money(c.total_price));
    set('[data-cx-count]', c.item_count ? '(' + c.item_count + ')' : '');
    var sh = $('[data-drawer-ship]', d); if (sh) { sh.classList.toggle('is-free', !!free); if (free) { var sm = $('[data-ship-msg]', sh); if (sm) sm.textContent = 'Congrats! You unlocked free shipping.'; } }
    var form = $('[data-cx-discount]', d); if (form) form.hidden = !c.items.length;
    var codes = $('[data-cx-codes]', d);
    if (codes) {
      var list = (c.discount_codes || []).filter(function (x) { return x && x.code; });
      codes.innerHTML = list.map(function (x) { return '<span class="cx-code' + (x.applicable === false ? ' is-off' : '') + '">' + esc(x.code) + (x.applicable === false ? ' · not valid for these items' : '') + '<button type="button" data-cx-remove-code aria-label="Remove code ' + esc(x.code) + '">×</button></span>'; }).join('');
    }
    // line savings note
    var lines = d.querySelectorAll('[data-drawer-body] .line');
    c.items.forEach(function (it, i) {
      var l = lines[i]; if (!l || l.querySelector('.cx-line-save')) return;
      var s = (it.original_line_price || 0) - (it.final_line_price || 0);
      if (s > 0) { var n = document.createElement('div'); n.className = 'cx-line-save'; n.textContent = 'You save ' + money(s); var info = l.querySelector('.line__info'); if (info) info.insertBefore(n, info.querySelector('.line__row')); }
    });
  }

  function upsell(c) {
    var box = $('[data-cx-upsell]', d), row = $('[data-cx-upsell-row]', d);
    if (!box || !row) return;
    if (!c.items.length) { box.hidden = true; return; }
    var inCart = {}; c.items.forEach(function (it) { inCart[it.product_id] = 1; });
    var pid = c.items[c.items.length - 1].product_id;
    var get = function (intent) {
      var k = pid + intent; if (recCache[k]) return Promise.resolve(recCache[k]);
      return fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=' + intent).then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (j) { recCache[k] = j.products || []; return recCache[k]; }).catch(function () { return []; });
    };
    get('complementary').then(function (p) { return p.length ? p : get('related'); }).then(function (ps) {
      ps = ps.filter(function (p) { return !inCart[p.id] && p.available; }).slice(0, 6);
      if (!ps.length) { box.hidden = true; return; }
      row.innerHTML = ps.map(function (p) {
        var vs = (p.variants || []).filter(function (v) { return v.available; });
        var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
        var pick = vs.length > 1 ? '<label class="visually-hidden" for="cxv' + p.id + '">Option</label><select id="cxv' + p.id + '" data-cx-variant>' + vs.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('') + '</select>' : '<input type="hidden" data-cx-variant value="' + (vs[0] && vs[0].id) + '">';
        var was = p.compare_at_price > p.price ? ' <s>' + money(p.compare_at_price) + '</s>' : '';
        return '<div class="cx-item"><a href="' + esc(p.url) + '" class="cx-item__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="80" height="106">' : '') + '</a><div class="cx-item__info"><a href="' + esc(p.url) + '" class="cx-item__title">' + esc(p.title) + '</a><div class="cx-item__price">' + money(p.price) + was + '</div><div class="cx-item__buy">' + pick + '<button type="button" class="cx-add" data-cx-add>+ Add</button></div></div></div>';
      }).join('');
      box.hidden = false;
    });
  }

  function refresh() {
    cart().then(function (c) {
      summary(c);
      var key = c.items.map(function (i) { return i.product_id; }).join(',');
      if (key !== lastKey) { lastKey = key; upsell(c); }
    });
  }

  function init() {
    d = document.getElementById('CartDrawer'); if (!d || !d.classList.contains('cx')) return;
    var body = $('[data-drawer-body]', d), t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(refresh, 60); }).observe(body, { childList: true });
    d.addEventListener('click', function (e) {
      var a = e.target.closest('[data-cx-add]');
      if (a) {
        var item = a.closest('.cx-item'), v = item.querySelector('[data-cx-variant]');
        if (!v || !v.value || !(S.u && S.u.addToCart)) return;
        a.disabled = true; a.textContent = 'Adding…';
        S.u.addToCart([{ id: parseInt(v.value, 10), quantity: 1 }]).catch(function () {}).then(function () { a.disabled = false; a.textContent = '+ Add'; });
        return;
      }
      if (e.target.closest('[data-cx-remove-code]')) { applyCode(''); }
    });
    var f = $('[data-cx-discount]', d);
    if (f) f.addEventListener('submit', function (e) { e.preventDefault(); var code = f.code.value.trim(); if (code) applyCode(code); });
  }

  function applyCode(code) {
    var msg = $('[data-cx-msg]', d);
    if (msg) msg.textContent = code ? 'Checking code…' : '';
    fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var hit = (c.discount_codes || []).filter(function (x) { return x.code && x.code.toLowerCase() === code.toLowerCase(); })[0];
        var ok = hit && hit.applicable !== false;
        if (msg) msg.textContent = !code ? 'Code removed.' : (ok ? 'Code applied.' : 'Sorry, “' + code + '” isn’t valid for the items in your bag.');
        if (code && !ok) return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: '' }) }).then(function (r) { return r.json(); }).then(function (c2) { if (S.u && S.u.renderCart) S.u.renderCart(c2); else refresh(); });
        if (S.u && S.u.renderCart) S.u.renderCart(c); else refresh();
        var inp = $('#CxCode', d); if (inp && hit && hit.applicable !== false) inp.value = '';
      })
      .catch(function () { if (msg) msg.textContent = 'Something went wrong. You can also enter the code at checkout.'; });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();